import { color } from "chart.js/helpers";

const HelloWorld = () => {
    return <h1 sytle={{ color: 'white' }}>Hello World!</h1>;
    }
    export default HelloWorld;